
// import React from 'react';
// import '../Styles/Slidebar.css';
// import { RiDashboardFill } from "react-icons/ri";
// import { FaUserGroup } from "react-icons/fa6";
// import { MdDirectionsBus } from "react-icons/md";
// import { MdOutlineBusAlert } from "react-icons/md";
// import { BiMale } from "react-icons/bi";
// import { FaRoute } from "react-icons/fa6";
// import { TbBrandBooking } from "react-icons/tb";
// import { MdPayment } from "react-icons/md";
// import { RiCoupon4Fill } from "react-icons/ri";
// import { FaUserTie } from "react-icons/fa6";
// import { FaCommentDollar } from "react-icons/fa6";
// import { MdAirlineSeatLegroomExtra } from "react-icons/md";
// import { CgProfile } from "react-icons/cg";
// import { TfiWrite } from "react-icons/tfi";

// const Slidebar = ({ activeMenu, setActiveMenu, onToggleCompact }) => {

// const menuItems = [
//   { id: 'dashboard', label: 'Dashboard', icon: <RiDashboardFill style={{width: "100%"}}/> },
//   { id: 'customers', label: 'Customer Report', icon: <FaUserGroup style={{width: "100%"}}/> },
//   { id: 'drivers', label: 'Driver Manage', icon: <MdDirectionsBus style={{width: "100%"}}/> }, 
//   { id: 'conductors', label: 'Conductor Manage', icon: <MdOutlineBusAlert style={{width: "100%"}}/> }, 
//   { id: 'bus-owners', label: 'Bus Owner Manage', icon: <BiMale style={{width: "100%"}}/> },
//    { id: 'employees', label: 'Employee Manage', icon: <FaUserTie style={{width: "100%"}}/> }, 
//   { id: 'routes', label: 'Route Manage', icon: <FaRoute style={{width: "100%"}}/> }, 
//   { id: 'bookings', label: 'Booking Manage', icon: <TbBrandBooking style={{width: "100%"}}/> },
//   { id: 'payments', label: 'Payment Report', icon: <MdPayment style={{width: "100%"}}/> },
//   { id: 'coupons', label: 'Coupon Manage', icon: <RiCoupon4Fill style={{width: "100%"}}/> },
//   { id: 'influencers', label: 'Influencer Manage', icon: <FaUserTie style={{width: "100%"}}/> },
//   { id: 'owner-commissions', label: 'Owner Commission', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'influencer-commissions', label: 'Influencer Commission', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'seat-management', label: 'Seat Management', icon: <MdAirlineSeatLegroomExtra style={{width: "100%"}}/> },
//   { id: 'profile', label: 'Profile Manage', icon: <CgProfile style={{width: "100%"}}/> },
//   { id: 'terms', label: 'Terms & Conditions', icon: <TfiWrite style={{width: "100%"}}/> },
//   // { id: 'chart', label: 'Bus Fare Chart', icon: '📝' },
// ];

//   return (
//     <div className="sidebar">
//       <div className="sidebar-header">
//         <h2>ROAM</h2>
//       </div>
      
//       <nav className="sidebar-nav">
//         <ul>
//           {menuItems.map(item => (
//             <li key={item.id}>
//               <button
//                 className={`nav-item ${activeMenu === item.id ? 'active' : ''}`}
//                 onClick={() => setActiveMenu(item.id)}
//               >
//                 <span className="nav-icon">{item.icon}</span>
//                 <span className="nav-label">{item.label}</span>
//               </button>
//             </li>
//           ))}
//         </ul>
//       </nav>
//     </div>
//   );
// };

// export default Slidebar;

// // Slidebar.js - Add freelancer menu item
// import React from 'react';
// import '../Styles/Slidebar.css';
// import { RiDashboardFill } from "react-icons/ri";
// import { FaUserGroup } from "react-icons/fa6";
// import { MdDirectionsBus } from "react-icons/md";
// import { MdOutlineBusAlert } from "react-icons/md";
// import { BiMale } from "react-icons/bi";
// import { FaRoute } from "react-icons/fa6";
// import { TbBrandBooking } from "react-icons/tb";
// import { MdPayment } from "react-icons/md";
// import { RiCoupon4Fill } from "react-icons/ri";
// import { FaUserTie } from "react-icons/fa6";
// import { FaCommentDollar } from "react-icons/fa6";
// import { MdAirlineSeatLegroomExtra } from "react-icons/md";
// import { CgProfile } from "react-icons/cg";
// import { TfiWrite } from "react-icons/tfi";
// import { FiUsers } from "react-icons/fi"; // Add this for freelancer icon

// const Slidebar = ({ activeMenu, setActiveMenu, onToggleCompact }) => {

// const menuItems = [
//   { id: 'dashboard', label: 'Dashboard', icon: <RiDashboardFill style={{width: "100%"}}/> },
//   { id: 'customers', label: 'Customer Report', icon: <FaUserGroup style={{width: "100%"}}/> },
//   { id: 'drivers', label: 'Driver Manage', icon: <MdDirectionsBus style={{width: "100%"}}/> }, 
//   { id: 'conductors', label: 'Conductor Manage', icon: <MdOutlineBusAlert style={{width: "100%"}}/> }, 
//   { id: 'bus-owners', label: 'Bus Owner Manage', icon: <BiMale style={{width: "100%"}}/> },
//   { id: 'employees', label: 'Employee Manage', icon: <FaUserTie style={{width: "100%"}}/> },
//   { id: 'freelancers', label: 'Freelancer Manage', icon: <FiUsers style={{width: "100%"}}/> },
//   { id: 'routes', label: 'Route Manage', icon: <FaRoute style={{width: "100%"}}/> }, 
//   { id: 'bookings', label: 'Booking Manage', icon: <TbBrandBooking style={{width: "100%"}}/> },
//   { id: 'payments', label: 'Payment Report', icon: <MdPayment style={{width: "100%"}}/> },
//   { id: 'coupons', label: 'Coupon Manage', icon: <RiCoupon4Fill style={{width: "100%"}}/> },
//   { id: 'influencers', label: 'Influencer Manage', icon: <FaUserTie style={{width: "100%"}}/> },
//   { id: 'owner-commissions', label: 'Owner Commission', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'influencer-commissions', label: 'Influencer Commission', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'seat-management', label: 'Seat Management', icon: <MdAirlineSeatLegroomExtra style={{width: "100%"}}/> },
//   { id: 'profile', label: 'Profile Manage', icon: <CgProfile style={{width: "100%"}}/> },
//   { id: 'terms', label: 'Terms & Conditions', icon: <TfiWrite style={{width: "100%"}}/> },
// ];

//   return (
//     <div className="sidebar">
//       <div className="sidebar-header">
//         <h2>ROAM</h2>
//       </div>
      
//       <nav className="sidebar-nav">
//         <ul>
//           {menuItems.map(item => (
//             <li key={item.id}>
//               <button
//                 className={`nav-item ${activeMenu === item.id ? 'active' : ''}`}
//                 onClick={() => setActiveMenu(item.id)}
//               >
//                 <span className="nav-icon">{item.icon}</span>
//                 <span className="nav-label">{item.label}</span>
//               </button>
//             </li>
//           ))}
//         </ul>
//       </nav>
//     </div>
//   );
// };

// export default Slidebar;

// Slidebar.js - Updated to filter menu items based on user role
// import React from 'react';
// import '../Styles/Slidebar.css';
// import { RiDashboardFill } from "react-icons/ri";
// import { FaUserGroup } from "react-icons/fa6";
// import { MdDirectionsBus } from "react-icons/md";
// import { MdOutlineBusAlert } from "react-icons/md";
// import { BiMale } from "react-icons/bi";
// import { FaRoute } from "react-icons/fa6";
// import { TbBrandBooking } from "react-icons/tb";
// import { MdPayment } from "react-icons/md";
// import { RiCoupon4Fill } from "react-icons/ri";
// import { FaUserTie } from "react-icons/fa6";
// import { FaCommentDollar } from "react-icons/fa6";
// import { MdAirlineSeatLegroomExtra } from "react-icons/md";
// import { CgProfile } from "react-icons/cg";
// import { TfiWrite } from "react-icons/tfi";
// import { FiUsers } from "react-icons/fi";

// // Define all menu items with their IDs
// const allMenuItems = [
//   { id: 'dashboard', label: 'Dashboard', icon: <RiDashboardFill style={{width: "100%"}}/> },
//   { id: 'customers', label: 'Customer Report', icon: <FaUserGroup style={{width: "100%"}}/> },
//   { id: 'GSTManagement', label: 'GSTManagement', icon: <FaUserGroup style={{width: "100%"}}/> },
//   { id: 'GSTAdminPanel', label: 'GSTAdminPanel Report', icon: <FaUserGroup style={{width: "100%"}}/> },
//   { id: 'drivers', label: 'Driver Manage', icon: <MdDirectionsBus style={{width: "100%"}}/> }, 
//   { id: 'conductors', label: 'Conductor Manage', icon: <MdOutlineBusAlert style={{width: "100%"}}/> }, 
//   { id: 'bus-owners', label: 'Bus Owner Manage', icon: <BiMale style={{width: "100%"}}/> },
//   { id: 'employees', label: 'Employee Manage', icon: <FaUserTie style={{width: "100%"}}/> },
//   { id: 'freelancers', label: 'Freelancer Manage', icon: <FiUsers style={{width: "100%"}}/> },
//   { id: 'routes', label: 'Route Manage', icon: <FaRoute style={{width: "100%"}}/> }, 
//   { id: 'masterroutes', label: 'Route Master', icon: <FaRoute style={{width: "100%"}}/> }, 
//   { id: 'bookings', label: 'Booking Manage', icon: <TbBrandBooking style={{width: "100%"}}/> },
//   { id: 'payments', label: 'Payment Report', icon: <MdPayment style={{width: "100%"}}/> },
//   { id: 'coupons', label: 'Coupon Manage', icon: <RiCoupon4Fill style={{width: "100%"}}/> },
//   { id: 'influencers', label: 'Influencer Manage', icon: <FaUserTie style={{width: "100%"}}/> },
//   { id: 'owner-commissions', label: 'Owner Commission', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'profit-report', label: 'Profit Report', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'expenses-report', label: 'Expenses Report', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'influencer-commissions', label: 'Influencer Commission', icon: <FaCommentDollar style={{width: "100%"}}/> },
//   { id: 'seat-management', label: 'Seat Management', icon: <MdAirlineSeatLegroomExtra style={{width: "100%"}}/> },
//   { id: 'profile', label: 'Profile Manage', icon: <CgProfile style={{width: "100%"}}/> },
//   { id: 'terms', label: 'Terms & Conditions', icon: <TfiWrite style={{width: "100%"}}/> },
// ];

// const Slidebar = ({ 
//   activeMenu, 
//   setActiveMenu, 
//   onToggleCompact,
//   userRole,
//   allowedMenus,
//   isAdmin,
//   isFreelancer 
// }) => {

//   // Filter menu items based on allowedMenus
//   const filteredMenuItems = allMenuItems.filter(item => 
//     allowedMenus.includes(item.id)
//   );

//   // Log for debugging
//   console.log('Slidebar - User Role:', userRole);
//   console.log('Slidebar - Allowed Menus:', allowedMenus);
//   console.log('Slidebar - Filtered Menu Items:', filteredMenuItems.map(item => item.id));

//   return (
//     <div className="sidebar">
//       <div className="sidebar-header">
//         <h2>ROAM</h2>
//         {isFreelancer && (
//           <span style={{
//             backgroundColor: '#ffc107',
//             color: '#212529',
//             padding: '2px 8px',
//             borderRadius: '12px',
//             fontSize: '10px',
//             fontWeight: '600',
//             marginLeft: '8px'
//           }}>
//             Freelancer
//           </span>
//         )}
//         {isAdmin && (
//           <span style={{
//             backgroundColor: '#28a745',
//             color: 'white',
//             padding: '2px 8px',
//             borderRadius: '12px',
//             fontSize: '10px',
//             fontWeight: '600',
//             marginLeft: '8px'
//           }}>
//             Admin
//           </span>
//         )}
//       </div>
      
//       <nav className="sidebar-nav">
//         <ul>
//           {filteredMenuItems.map(item => (
//             <li key={item.id}>
//               <button
//                 className={`nav-item ${activeMenu === item.id ? 'active' : ''}`}
//                 onClick={() => setActiveMenu(item.id)}
//               >
//                 <span className="nav-icon">{item.icon}</span>
//                 <span className="nav-label">{item.label}</span>
//               </button>
//             </li>
//           ))}
//         </ul>
//       </nav>

//       {/* Optional: Add footer with user info */}
//       <div className="sidebar-footer" style={{
//         padding: '20px',
//         borderTop: '1px solid #444',
//         marginTop: 'auto',
//         fontSize: '12px',
//         color: '#888'
//       }}>
//         <div>Logged in as:</div>
//         <div style={{ fontWeight: 'bold', color: '#fff' }}>
//           {isFreelancer ? 'Freelancer' : isAdmin ? 'Administrator' : 'User'}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Slidebar;

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../Styles/Slidebar.css';
import { RiDashboardFill } from "react-icons/ri";
import { FaUserGroup } from "react-icons/fa6";
import { MdDirectionsBus } from "react-icons/md";
import { MdOutlineBusAlert } from "react-icons/md";
import { BiMale } from "react-icons/bi";
import { FaRoute } from "react-icons/fa6";
import { TbBrandBooking } from "react-icons/tb";
import { MdPayment } from "react-icons/md";
import { RiCoupon4Fill } from "react-icons/ri";
import { FaUserTie } from "react-icons/fa6";
import { FaCommentDollar } from "react-icons/fa6";
import { MdAirlineSeatLegroomExtra } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { TfiWrite } from "react-icons/tfi";
import { FiUsers } from "react-icons/fi";

// Define all menu items with their IDs
const allMenuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: <RiDashboardFill style={{width: "100%"}}/> },
  { id: 'customers', label: 'Customer Report', icon: <FaUserGroup style={{width: "100%"}}/> },
  { id: 'GSTManagement', label: 'GSTManagement', icon: <FaUserGroup style={{width: "100%"}}/> },
  { id: 'GSTAdminPanel', label: 'GSTAdminPanel Report', icon: <FaUserGroup style={{width: "100%"}}/> },
  { id: 'drivers', label: 'Driver Manage', icon: <MdDirectionsBus style={{width: "100%"}}/> }, 
  { id: 'conductors', label: 'Conductor Manage', icon: <MdOutlineBusAlert style={{width: "100%"}}/> }, 
  { id: 'bus-owners', label: 'Bus Owner Manage', icon: <BiMale style={{width: "100%"}}/> },
  { id: 'BusManagement', label: 'Bus Manage', icon: <BiMale style={{width: "100%"}}/> },
  { id: 'employees', label: 'Employee Manage', icon: <FaUserTie style={{width: "100%"}}/> },
  { id: 'freelancers', label: 'Freelancer Manage', icon: <FiUsers style={{width: "100%"}}/> },
  { id: 'routes', label: 'Route Manage', icon: <FaRoute style={{width: "100%"}}/> }, 
  { id: 'busroutes', label: 'Bus Route Manage', icon: <FaRoute style={{width: "100%"}}/> }, 
  { id: 'masterroutes', label: 'Route Master', icon: <FaRoute style={{width: "100%"}}/> }, 
  { id: 'bookings', label: 'Booking Manage', icon: <TbBrandBooking style={{width: "100%"}}/> },
  { id: 'payments', label: 'Payment Report', icon: <MdPayment style={{width: "100%"}}/> },
  { id: 'coupons', label: 'Coupon Manage', icon: <RiCoupon4Fill style={{width: "100%"}}/> },
  { id: 'influencers', label: 'Influencer Manage', icon: <FaUserTie style={{width: "100%"}}/> },
  { id: 'owner-commissions', label: 'Owner Commission', icon: <FaCommentDollar style={{width: "100%"}}/> },
  { id: 'profit-report', label: 'Profit Report', icon: <FaCommentDollar style={{width: "100%"}}/> },
  { id: 'expenses-report', label: 'Expenses Report', icon: <FaCommentDollar style={{width: "100%"}}/> },
  { id: 'influencer-commissions', label: 'Influencer Commission', icon: <FaCommentDollar style={{width: "100%"}}/> },
  { id: 'seat-management', label: 'Seat Management', icon: <MdAirlineSeatLegroomExtra style={{width: "100%"}}/> },
  { id: 'customer-care', label: 'Customer Care', icon: <FaUserGroup style={{width: "100%"}}/> },
  { id: 'platform-management', label: 'platform-management', icon: <MdAirlineSeatLegroomExtra style={{width: "100%"}}/> },
  { id: 'BookingPolicyManagement', label: 'BookingPolicyManagement', icon: <MdAirlineSeatLegroomExtra style={{width: "100%"}}/> },
  { id: 'profile', label: 'Profile Manage', icon: <CgProfile style={{width: "100%"}}/> },
  { id: 'terms', label: 'Terms & Conditions', icon: <TfiWrite style={{width: "100%"}}/> },
  // { id: 'chart', label: 'Bus Fare Chart', icon: <MdDirectionsBus style={{width: "100%"}}/> },
];

const Slidebar = ({ 
  activeMenu, 
  setActiveMenu, 
  onToggleCompact,
  userRole,
  allowedMenus,
  isAdmin,
  isFreelancer 
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Filter menu items based on allowedMenus
  const filteredMenuItems = allMenuItems.filter(item => 
    allowedMenus.includes(item.id)
  );

  const handleMenuClick = (menuId) => {
    // Update the active menu state
    setActiveMenu(menuId);
    // Navigate using React Router without page reload
    navigate(`/${menuId}`);
  };

  // Check if current route matches menu item
  const isActive = (menuId) => {
    const currentPath = location.pathname.substring(1); // Remove leading slash
    return currentPath === menuId || (menuId === 'dashboard' && currentPath === '');
  };

  // Log for debugging
  console.log('Slidebar - Current Path:', location.pathname);
  console.log('Slidebar - User Role:', userRole);
  console.log('Slidebar - Allowed Menus:', allowedMenus);
  console.log('Slidebar - Filtered Menu Items:', filteredMenuItems.map(item => item.id));

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>ROAM</h2>
        {isFreelancer && (
          <span style={{
            backgroundColor: '#ffc107',
            color: '#212529',
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '10px',
            fontWeight: '600',
            marginLeft: '8px'
          }}>
            Freelancer
          </span>
        )}
        {isAdmin && (
          <span style={{
            backgroundColor: '#28a745',
            color: 'white',
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '10px',
            fontWeight: '600',
            marginLeft: '8px'
          }}>
            Admin
          </span>
        )}
      </div>
      
      <nav className="sidebar-nav">
        <ul>
          {filteredMenuItems.map(item => (
            <li key={item.id}>
              <button
                className={`nav-item ${isActive(item.id) ? 'active' : ''}`}
                onClick={() => handleMenuClick(item.id)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Optional: Add footer with user info */}
      <div className="sidebar-footer" style={{
        padding: '20px',
        borderTop: '1px solid #444',
        marginTop: 'auto',
        fontSize: '12px',
        color: '#888'
      }}>
        <div>Logged in as:</div>
        <div style={{ fontWeight: 'bold', color: '#fff' }}>
          {isFreelancer ? 'Freelancer' : isAdmin ? 'Administrator' : 'User'}
        </div>
      </div>
    </div>
  );
};

export default Slidebar;